import { render, staticRenderFns } from "./toggle-switch.html?vue&type=template&id=5496d163&scoped=true&"
import script from "./toggle-switch.js?vue&type=script&lang=js&"
export * from "./toggle-switch.js?vue&type=script&lang=js&"
import style0 from "./toggle-switch.scss?vue&type=style&index=0&id=5496d163&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496d163",
  null
  
)

export default component.exports